import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { UITextMode } from './ui-text-mode.enum';
import { UITextStyling } from "./ui-text-styling";
import { UITextWhitespace } from "./ui-text-whitespace.enum";

@Component({
    selector: 'ui-text',
    templateUrl: './ui-text.component.html',
})
export class UITextComponent implements AfterViewInit {
    private _mode: UITextMode | string = UITextMode.default;
    @ViewChild('text') text: ElementRef<HTMLSpanElement>;
    @Input() set mode(val: UITextMode | string) {
        this._mode = val;
        this.styling.props.mode = val;
    };
    get mode(): UITextMode | string {
        return this._mode;
    }
    @Input() whitespace: UITextWhitespace | string = UITextWhitespace.normal;

    styling = new UITextStyling({ mode: this.mode, whitespace: this.whitespace });

    constructor(private host: ElementRef<HTMLElement>) {
    }

    ngAfterViewInit(): void {
        this.removeAnythingOtherThanText();
        this.host.nativeElement.classList.add('≈inline-block');
    }

    removeAnythingOtherThanText(): void {
        const allowedTagNames = [
            'A',
            'P',
            'B',
            'I',
            'BR'
        ];
        Array.from(this.text.nativeElement.childNodes).forEach(child => {
            if (child instanceof HTMLElement && !allowedTagNames.includes(child.tagName)) {
                child.remove();
            }
        });
    }
}
